export default function VRFamiliesSection() {
  return (
    <section className="bg-white py-16 px-6 lg:px-14 border-t border-[#EDE8E0]">
      <div className="max-w-3xl mx-auto">
        <h2 className="font-cormorant text-3xl md:text-4xl text-[#1A1A18] font-medium mb-5">
          Best Vacation Rentals in Highlands, NC for Families
        </h2>
        <div className="space-y-4 text-[#5C5850] font-jost text-sm leading-relaxed">
          <p>
            <strong className="text-[#2D4A3E] font-medium">Glen Falls Luxury Cabin</strong> is a strong option for families visiting Highlands, NC. It offers multiple sleeping areas, a full kitchen, and outdoor space, which makes it easier for groups to stay comfortably. Its location also makes it convenient to access both downtown Highlands and nearby hiking and waterfalls.
          </p>
          <p>
            Stag Ridge is another well-suited choice for families or small groups, with room for up to six guests, a full kitchen, and a wraparound deck. Both properties are pet friendly, which is a practical plus for families traveling with dogs.
          </p>
        </div>
      </div>
    </section>
  );
}
